import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Orgstyle } from '@src/app/helpers/dynamicstyle/model/orgstyle';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { PersonOrganization } from '../../model/personorganization';

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  personUrl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/';
  
  constructor(private http:HttpClient) { }

  getPersonAuth(orgId:string, personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId+'/person/'+personId+'/auth',httpOptions)
  }
  getOrgstyles(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgstyle[]>(environment.apiUrl+'/organization/'+orgId+'/whitelabel/list',httpOptions);
  }
}
